import { IFilter } from '@vacationtracker/shared/types/filter'
import isEmpty from 'lodash/isEmpty'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const filterData = (filter: IFilter, data: any[]) => {
  const { labelIds, locationIds, teamIds } = filter
  const dataFiltered = data
    .filter((calendar) => {
      if (isEmpty(locationIds)) {
        return true
      }
      if (isEmpty(calendar?.locations)) {
        return true
      }
      return locationIds.find((id) => calendar?.locations?.includes(id))
    })
    .filter((calendar) => {
      if (isEmpty(teamIds)) {
        return true
      }
      if (isEmpty(calendar?.departments)) {
        return true
      }
      return teamIds.find((id) => calendar?.departments?.includes(id))
    })
    .filter((calendar) => {
      if (isEmpty(labelIds)) {
        return true
      }
      if (isEmpty(calendar?.labels)) {
        return true
      }
      return labelIds.find((id) => calendar?.labels && calendar.labels.includes(id))
    })
  return dataFiltered
}
